import { GlobalAppEventEnum } from "@ryde/shared";

import { useFormMapDrawerResize } from "../../../../hooks";

interface IUseRideDrawerResizeParams {
  drawerNumber?: number;
}

export const useRideDrawerResize = (params: IUseRideDrawerResizeParams = {}) =>
  useFormMapDrawerResize({
    ...params,
    mapResizeEvent: GlobalAppEventEnum.RESIZE_RIDE_MAP,
  });
